import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'padspin-footer',
  template: `
    <footer class="border-t border-surface bg-surface-50 dark:bg-surface-950">
      <div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div class="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div class="col-span-2">
            <img
              ngSrc="/assets/web/padspin-logo-green-blue-wordmark.svg"
              alt="Padspin"
              width="153"
              height="45"
              class="h-8 w-auto"
            />
            <p class="mt-4 max-w-sm text-sm text-muted-color">
              AI-powered home &amp; apartment leasing. Born and raised in NYC.
            </p>
            <ul class="mt-6 flex flex-row items-center gap-4 text-primary">
              <li>
                <a
                  href="https://www.facebook.com/padspin/"
                  target="_blank"
                  rel="noopener"
                  aria-label="Padspin on Facebook"
                  ><svg
                    width="28"
                    height="28"
                    viewBox="0 0 48 49"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M44 24.6213C44 13.508 35.0467 4.5 24 4.5C12.9533 4.5 4 13.508 4 24.6213C4 34.6667 11.312 42.9907 20.8747 44.5V30.4387H15.7973V24.62H20.8747V20.188C20.8747 15.1453 23.86 12.3587 28.4293 12.3587C30.616 12.3587 32.9067 12.752 32.9067 12.752V17.704H30.3827C27.8987 17.704 27.1253 19.256 27.1253 20.848V24.6213H32.672L31.7853 30.4373H27.1253V44.5C36.688 42.9907 44 34.6667 44 24.6213Z"
                    /></svg
                ></a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/getpadspin?utm_medium=site"
                  target="_blank"
                  rel="noopener"
                  aria-label="Padspin on Instagram"
                  ><svg
                    width="28"
                    height="28"
                    viewBox="0 0 48 49"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24 6.5C19.1112 6.5 18.4992 6.5204 16.5792 6.608C14.6628 6.6956 13.3536 7.0004 12.2088 7.4456C11.0088 7.8968 9.9204 8.6048 9.0204 9.5216C8.10507 10.4206 7.39663 11.5082 6.9444 12.7088C6.5016 13.8536 6.1956 15.164 6.108 17.0804C6.0216 18.9992 6 19.61 6 24.5C6 29.39 6.0204 30.0008 6.108 31.9208C6.1956 33.8372 6.5004 35.1464 6.9456 36.2912C7.3968 37.4912 8.1048 38.5796 9.0216 39.4796C9.92058 40.3949 11.0082 41.1033 12.2088 41.5556C13.3536 41.9996 14.6628 42.3044 16.5792 42.392C18.4992 42.4796 19.1112 42.5 24 42.5C28.8888 42.5 29.5008 42.4796 31.4208 42.392C33.3372 42.3044 34.6464 41.9996 35.7912 41.5544C36.9912 41.1032 38.0796 40.3952 38.9796 39.4784C39.8949 38.5794 40.6034 37.4918 41.0556 36.2912C41.4996 35.1464 41.8044 33.8372 41.892 31.9208C41.9796 30.0008 42 29.3888 42 24.5C42 19.6112 41.9796 18.9992 41.892 17.0792C41.8044 15.1628 41.4996 13.8536 41.0544 12.7088C40.6025 11.5077 39.894 10.4196 38.9784 9.5204C38.0794 8.60507 36.9918 7.89663 35.7912 7.4444C34.6464 7.0016 33.336 6.6956 31.4196 6.608C29.5008 6.5216 28.89 6.5 24 6.5ZM24 9.7436C28.806 9.7436 29.376 9.7616 31.2744 9.848C33.0288 9.9284 33.9816 10.22 34.6164 10.4684C35.4564 10.7936 36.0564 11.1848 36.6864 11.8136C37.3164 12.4436 37.7064 13.0436 38.0316 13.8836C38.2788 14.5184 38.5716 15.4712 38.652 17.2256C38.7384 19.124 38.7564 19.694 38.7564 24.5C38.7564 29.306 38.7384 29.876 38.652 31.7744C38.5716 33.5288 38.28 34.4816 38.0316 35.1164C37.7435 35.8983 37.2839 36.6056 36.6864 37.1864C36.1057 37.784 35.3983 38.2437 34.6164 38.5316C33.9816 38.7788 33.0288 39.0716 31.2744 39.152C29.376 39.2384 28.8072 39.2564 24 39.2564C19.1928 39.2564 18.624 39.2384 16.7256 39.152C14.9712 39.0716 14.0184 38.78 13.3836 38.5316C12.6017 38.2435 11.8944 37.7839 11.3136 37.1864C10.7162 36.6055 10.2566 35.8982 9.9684 35.1164C9.7212 34.4816 9.4284 33.5288 9.348 31.7744C9.2616 29.876 9.2436 29.306 9.2436 24.5C9.2436 19.694 9.2616 19.124 9.348 17.2256C9.4284 15.4712 9.72 14.5184 9.9684 13.8836C10.2936 13.0436 10.6848 12.4436 11.3136 11.8136C11.8943 11.2161 12.6017 10.7564 13.3836 10.4684C14.0184 10.2212 14.9712 9.9284 16.7256 9.848C18.624 9.7616 19.194 9.7436 24 9.7436Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24 30.506C23.2113 30.506 22.4303 30.3507 21.7016 30.0488C20.973 29.747 20.3109 29.3046 19.7532 28.7469C19.1955 28.1892 18.7531 27.5271 18.4512 26.7984C18.1494 26.0697 17.994 25.2887 17.994 24.5C17.994 23.7113 18.1494 22.9303 18.4512 22.2016C18.7531 21.4729 19.1955 20.8108 19.7532 20.2531C20.3109 19.6954 20.973 19.253 21.7016 18.9512C22.4303 18.6494 23.2113 18.494 24 18.494C25.5929 18.494 27.1206 19.1268 28.2469 20.2531C29.3733 21.3795 30.006 22.9071 30.006 24.5C30.006 26.0929 29.3733 27.6205 28.2469 28.7469C27.1206 29.8732 25.5929 30.506 24 30.506ZM24 15.248C21.5463 15.248 19.193 16.2228 17.4579 17.9579C15.7228 19.6929 14.748 22.0462 14.748 24.5C14.748 26.9538 15.7228 29.3071 17.4579 31.0422C19.193 32.7772 21.5463 33.752 24 33.752C26.4538 33.752 28.8071 32.7772 30.5422 31.0422C32.2773 29.3071 33.252 26.9538 33.252 24.5C33.252 22.0462 32.2773 19.6929 30.5422 17.9579C28.8071 16.2228 26.4538 15.248 24 15.248ZM35.9436 15.08C35.9436 15.66 35.7132 16.2163 35.3031 16.6264C34.8929 17.0366 34.3367 17.267 33.7566 17.267C33.1766 17.267 32.6203 17.0366 32.2102 16.6264C31.8001 16.2163 31.5696 15.66 31.5696 15.08C31.5696 14.5 31.8001 13.9437 32.2102 13.5336C32.6203 13.1234 33.1766 12.893 33.7566 12.893C34.3367 12.893 34.8929 13.1234 35.3031 13.5336C35.7132 13.9437 35.9436 14.5 35.9436 15.08Z"
                    /></svg
                ></a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/padspin"
                  target="_blank"
                  rel="noopener"
                  aria-label="Padspin on LinkedIn"
                  ><svg
                    width="28"
                    height="28"
                    viewBox="0 0 48 49"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M42 9.14706V39.8529C42 40.555 41.7211 41.2283 41.2247 41.7247C40.7283 42.2211 40.055 42.5 39.3529 42.5H8.64706C7.94502 42.5 7.27173 42.2211 6.77531 41.7247C6.27889 41.2283 6 40.555 6 39.8529V9.14706C6 8.44502 6.27889 7.77173 6.77531 7.27531C7.27173 6.77889 7.94502 6.5 8.64706 6.5H39.3529C40.055 6.5 40.7283 6.77889 41.2247 7.27531C41.7211 7.77173 42 8.44502 42 9.14706V9.14706ZM16.5882 20.2647H11.2941V37.2059H16.5882V20.2647ZM17.0647 14.4412C17.0675 14.0407 16.9914 13.6436 16.8407 13.2726C16.69 12.9016 16.4677 12.5638 16.1866 12.2787C15.9054 11.9936 15.5707 11.7666 15.2018 11.6108C14.8329 11.455 14.4369 11.3734 14.0365 11.3706H13.9412C13.1268 11.3706 12.3458 11.6941 11.7699 12.2699C11.1941 12.8458 10.8706 13.6268 10.8706 14.4412C10.8706 15.2555 11.1941 16.0366 11.7699 16.6124C12.3458 17.1883 13.1268 17.5118 13.9412 17.5118V17.5118C14.3417 17.5216 14.7402 17.4525 15.1139 17.3083C15.4877 17.164 15.8293 16.9476 16.1194 16.6713C16.4095 16.395 16.6423 16.0642 16.8045 15.6979C16.9667 15.3316 17.0551 14.937 17.0647 14.5365V14.4412ZM36.7059 26.9141C36.7059 21.8212 33.4659 19.8412 30.2471 19.8412C29.1932 19.7884 28.1438 20.0129 27.2037 20.4922C26.2637 20.9715 25.4657 21.689 24.8894 22.5729H24.7412V20.2647H19.7647V37.2059H25.0588V28.1953C24.9823 27.2725 25.273 26.3567 25.8677 25.6469C26.4625 24.9372 27.3133 24.4908 28.2353 24.4047H28.4365C30.12 24.4047 31.3694 25.4635 31.3694 28.1318V37.2059H36.6635L36.7059 26.9141Z"
                    /></svg
                ></a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@padspin"
                  target="_blank"
                  rel="noopener"
                  aria-label="Padspin on TikTok"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 48 48"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M36.1395 13.2656C35.8981 13.1408 35.6631 13.0041 35.4354 12.8558C34.7732 12.418 34.166 11.9021 33.627 11.3193C32.2783 9.77621 31.7746 8.21071 31.5891 7.11464H31.5966C31.4416 6.20485 31.5056 5.61621 31.5153 5.61621H25.3726V29.3691C25.3726 29.688 25.3726 30.0032 25.3592 30.3147C25.3592 30.3534 25.3554 30.3892 25.3532 30.4309C25.3532 30.448 25.3532 30.4659 25.3495 30.4838C25.3495 30.4883 25.3495 30.4927 25.3495 30.4972C25.2847 31.3495 25.0115 32.1727 24.5539 32.8946C24.0963 33.6165 23.4683 34.2149 22.7252 34.6371C21.9507 35.0777 21.0747 35.3089 20.1836 35.3077C17.3216 35.3077 15.002 32.974 15.002 30.0919C15.002 27.2098 17.3216 24.876 20.1836 24.876C20.7253 24.8755 21.2638 24.9608 21.7789 25.1286L21.7863 18.8741C20.2226 18.6721 18.634 18.7964 17.1207 19.2391C15.6074 19.6818 14.2022 20.4333 12.9939 21.4463C11.9352 22.3662 11.045 23.4638 10.3637 24.6898C10.1043 25.1368 9.12601 26.9333 9.00753 29.849C8.93302 31.5039 9.43002 33.2184 9.66696 33.927V33.9419C9.81599 34.3592 10.3935 35.7831 11.3345 36.9835C12.0934 37.9464 12.99 38.7922 13.9954 39.4938V39.4789L14.0103 39.4938C16.984 41.5145 20.2812 41.3819 20.2812 41.3819C20.8519 41.3588 22.7639 41.3819 24.9352 40.3529C27.3434 39.2121 28.7144 37.5125 28.7144 37.5125C29.5903 36.497 30.2868 35.3396 30.7739 34.0902C31.3298 32.629 31.5153 30.8765 31.5153 30.1761V17.5746C31.5898 17.6193 32.5823 18.2758 32.5823 18.2758C32.5823 18.2758 34.0122 19.1923 36.2431 19.7891C37.8436 20.2138 40 20.3032 40 20.3032V14.2052C39.2445 14.2872 37.7103 14.0487 36.1395 13.2656Z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@getpadspin"
                  target="_blank"
                  rel="noopener"
                  aria-label="Padspin on YouTube"
                  ><svg
                    width="28"
                    height="28"
                    viewBox="0 0 48 48"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35.5658 10H12.4328C7.89415 10 4.21484 13.6793 4.21484 18.218V29.782C4.21484 34.3207 7.89415 38 12.4328 38H35.5658C40.1045 38 43.7838 34.3207 43.7838 29.782V18.218C43.7838 13.6793 40.1045 10 35.5658 10ZM30.0081 24.5626L19.188 29.7232C18.8997 29.8607 18.5667 29.6505 18.5667 29.3311V18.6875C18.5667 18.3635 18.9085 18.1536 19.1974 18.3L30.0174 23.7831C30.3391 23.9461 30.3336 24.4074 30.0081 24.5626Z"
                    /></svg
                ></a>
              </li>
            </ul>
          </div>
          <div class="md:text-right">
            <div class="text-sm font-semibold text-color">Product</div>
            <ul class="mt-4 space-y-2 text-sm text-muted-color">
              <li>
                <a
                  routerLink="/how-it-works"
                  class="transition-colors hover:text-color"
                  >How it works</a
                >
              </li>
              <li>
                <a
                  routerLink="/pricing"
                  class="transition-colors hover:text-color"
                  >Pricing</a
                >
              </li>
              <li>
                <a
                  routerLink="/cities"
                  class="transition-colors hover:text-color"
                  >Cities</a
                >
              </li>
              <li>
                <a
                  routerLink="/property-management"
                  class="transition-colors hover:text-color"
                  >Property Management</a
                >
              </li>
              <li>
                <a
                  routerLink="/talk-to-sales"
                  class="transition-colors hover:text-color"
                  >Talk to sales</a
                >
              </li>
              <li>
                <a routerLink="/move" class="transition-colors hover:text-color"
                  >Hire movers</a
                >
              </li>
            </ul>
          </div>
          <div class="text-right">
            <div class="text-sm font-semibold text-color">Company</div>
            <ul class="mt-4 space-y-2 text-sm text-muted-color">
              <li>
                <a
                  routerLink="/press"
                  class="transition-colors hover:text-color"
                  >Press</a
                >
              </li>
              <li>
                <a
                  routerLink="/fair-housing"
                  class="transition-colors hover:text-color"
                  >Fair Housing</a
                >
              </li>
              <li>
                <a routerLink="/blog" class="transition-colors hover:text-color"
                  >Blog</a
                >
              </li>
              <li>
                <a
                  href="mailto:support@padspin.com"
                  class="transition-colors hover:text-color"
                  >Contact</a
                >
              </li>
              <li>
                <a
                  routerLink="/agents"
                  class="transition-colors hover:text-color"
                  >Agents</a
                >
              </li>
              <li>
                <a
                  routerLink="/terms-of-service"
                  class="transition-colors hover:text-color"
                  >Terms of Service</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          class="mt-12 flex flex-col items-start justify-between gap-2 border-t border-surface pt-6 text-xs text-muted-color sm:flex-row sm:items-center"
        >
          <div>
            Copyright © 2014 — {{ year() }} Padspin · Born and raised in NYC
          </div>
          <div>
            <a routerLink="/fair-housing" class="flex flex-row items-center">
              <!-- Fair Housing Logo -->
              <svg
                version="1.2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -143.0000000000002 1977.0000000000002 1977.0000000000002"
                width="1978"
                height="1978"
                class="w-4 h-4  fill-gray-500 mr-2"
              >
                <path
                  fill-rule="evenodd"
                  d="m351 766.8l635-427 643 429v660h-1279zm-340.2-112.5l-0.7 261.1 129 0.2-0.1 776.6 1700 2.2-0.9-777.9 127.3 0.4 0.4-260.8-977.1-658.4z"
                />
                <path
                  fill-rule="evenodd"
                  d="m651.8 1029.9l671 0.4 3.1 275.8-672.8 1.3z"
                />
                <path
                  fill-rule="evenodd"
                  d="m651.8 707.9l671 0.4 3.1 275.8-672.8 1.3z"
                />
              </svg>
              <span>Fair Housing and Equal Opportunity</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgOptimizedImage, RouterLink],
})
export class FooterComponent {
  protected year = signal(new Date().getFullYear());
}
